import { render, staticRenderFns } from "./IGV2CommentManagement.vue?vue&type=template&id=46bd9eca&scoped=true"
import script from "./IGV2CommentManagement.vue?vue&type=script&lang=js"
export * from "./IGV2CommentManagement.vue?vue&type=script&lang=js"
import style0 from "./IGV2CommentManagement.vue?vue&type=style&index=0&id=46bd9eca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bd9eca",
  null
  
)

export default component.exports